module.exports = __webpack_public_path__ + "static/media/labelTdkCocok.9622e62b.mp3";